const state = {
  isPreviewOpen: false,
  previewPoint: null
}

const mutations = {
  SET_PREVIEW_OPEN(state, isOpen) {
    state.isPreviewOpen = isOpen
  },
  SET_PREVIEW_POINT(state, point) {
    state.previewPoint = point
  }
}

const actions = {
  openPreview({ commit }, point) {
    console.log('=== POINT PREVIEW STORE - OPEN PREVIEW ===')
    console.log('Opening preview for point:', point)
    console.log('Point data structure:', {
      hasPoint: !!point,
      hasPointId: !!point?.point?.id,
      hasDataPointId: !!point?.data?.point?.id,
      hasId: !!point?.id,
      pointId: point?.point?.id || point?.data?.point?.id || point?.id
    })
    
    commit('SET_PREVIEW_POINT', point)
    commit('SET_PREVIEW_OPEN', true)
    
    console.log('Preview state updated in store')
  },
  closePreview({ commit }) {
    console.log('=== POINT PREVIEW STORE - CLOSE PREVIEW ===')
    console.log('Closing preview')
    
    commit('SET_PREVIEW_OPEN', false)
    commit('SET_PREVIEW_POINT', null)
    
    console.log('Preview state cleared in store')
  }
}

const getters = {
  isPreviewOpen: state => state.isPreviewOpen,
  previewPoint: state => state.previewPoint
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 